import { DataActions, ErrorActions } from 'common/constants/actions';

function isValidObject(obj) {
  // Check if the object is valid
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  // Iterate over each property of the object
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      // If the value is an object, recursively check its properties
      if (typeof value === 'object' && value !== null) {
        if (isValidObject(value)) {
          return true; // Found valid nested value
        }
        // Continue checking other properties if this nested object was invalid
      }
      // If the value is not undefined or null, it's a valid entry
      else if (value !== undefined && value !== null) {
        return true; // There's at least one valid property
      }
    }
  }

  // If all values are undefined or null
  return false;
}

const initialState = {
  filtered_data: [],
  filtered_last_data: [],
  question_structure: {},
  category_structure: {},
  selected: { id: 0 },
  dates: [],
  raw_data: [],
  sub: 1,
  filters: [],
  new_filters: [],
  anchor: null,
  nav: null,
  survey_version: null,
};

export default function Audit(state = initialState, action) {
  switch (action.type) {
    case DataActions.SET_FILTERED:
      return {
        ...state,
        filtered_data: action.payload,
      };
    case DataActions.SET_FILTERED_LAST:
      return {
        ...state,
        filtered_last_data: action.payload,
      };
    case DataActions.SET_SELECTED_QUESTION:
      return {
        ...state,
        selected: action.payload,
      };
    case DataActions.SET_DATES:
      return {
        ...state,
        dates: action.payload,
      };
    case DataActions.SET_CATEGORY:
      return {
        ...state,
        category_structure: action.payload,
      };
    case DataActions.SET_RAW:
      return {
        ...state,
        raw_data: action.payload,
      };
    case DataActions.SET_QUESTIONS:
      if (!isValidObject(action.payload)) {
        return state;
      }

      return {
        ...state,
        question_structure: action.payload,
      };
    case DataActions.SET_SELECTED_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ErrorActions.CLEAR_ALL:
      return {
        ...state,
        filtered_data: [],
        filtered_last_data: [],
        question_structure: {},
        category_structure: {},
        selected: { id: 0 },
        dates: [],
        raw_data: [],
        sub: 1,
        filters: [],
        new_filters: [],
        anchor: null,
        nav: null,
        survey_version: null,
      };
    default:
      return state;
  }
}
